module.exports = __webpack_public_path__ + "img/smartphone-color.3d05cb3d.png";